import { CANONICAL_HEX_SIZE } from '../../../../codebook.js';
import React from 'react';
import StraightRiver2 from './components/StraightRiver2.js';
export default function Straight2({ center, dimensions, size, ...props }) {
    return (React.createElement("g", { transform: `translate(${center.x - dimensions.width / 2} ${center.y - dimensions.height / 2}) scale(${size / CANONICAL_HEX_SIZE})` },
        React.createElement(StraightRiver2, { hasFlatTop: props.hasFlatTop })));
}
